import { Button, PlusIcon } from "melco-ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export const AddGroupButton: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Button
        type="primary"
        icon={<PlusIcon />}
        data-cy-id="add-new-machine-group-button"
        onClick={() => {
          navigate("/reporting/machine/groups/new");
        }}
      >
        {t("reporting.machinegroups.actions.add.button")}
      </Button>
    </>
  );
};
